export class WidgetFieldSetting {
    WidgetName: boolean = true;
    StoreTitle: boolean = false;
    MonitorType: boolean = false;
    FirstWaveTime: boolean = false;
    DaySetting: boolean = false;
    PickType: boolean = false;
    ShipmentType: boolean = false;
    OrderPriority: boolean = false;
    HasLithirum: boolean = false;
    CommitDate: boolean = false;
    CountryCode: boolean = false;
    Carrier: boolean = false;
    PassThru: boolean = false;
    WaveType: boolean = false;
    BatchWave: boolean = false;
    SummaryType: boolean = false;
    DateRange: boolean = false;
    VarianceType: boolean = false;
    OpenTasksType: boolean = false;
    ShiptoCountry: boolean = false;
    ZoneBalancing: boolean = false;
    WaveOrderStatusType: boolean = false;
    WaveOrderStatusActive: boolean = false;
    ReleasedWaveLookup: boolean = false;
    PutwallLookup: boolean = false;
}


// WEBPACK FOOTER //
// ./src/app/models/WidgetFieldSetting.ts